import { Component, EventEmitter, input, model, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'app-accomplishment-submission',
    templateUrl: './accomplishment-submission.component.html',
    styleUrls: ['./accomplishment-submission.component.scss'],
    standalone: false
})


export class AccomplishmentSubmissionComponent implements OnChanges, OnInit {
  report = input.required<any>();
  reportList = input.required<any>();
  nav = model.required<string>();
    @Output() loaded = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    private readonly titleService: Title,
    private readonly router: Router,
  ) {
    this.titleService.setTitle("BAER - Accomplishment Report Submitted")
  }

  ngOnInit(): void {
    this.loaded.emit(true);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    if (this.nav() == 'close') {
      this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.reportList()[0].assessment_id, tab: 2 } });
    }
  }
}
